<template>
<div>
    <div class="card" v-loading="loading" element-loading-text="Cargando..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
        <div class="card-body">
            <form @submit.prevent="submit" id="upload" method="post">
                <div class="row text-center">
                    <div class="col-md-3 col-lg-3">
                        <div class="form-group">
                            <label>Título de la dinámica</label>
                            <input type="text" v-model="form.name" placeholder="Titulo de la dinámica" />
                        </div>
                    </div>

                    <div class="col-md-3 col-lg-3">
                        <div class="form-group">
                            <label>Tipo de juego</label>

                            <select v-model="form.game_type" id="item">
                                <option value="0" disabled selected>Seleccione Categoría</option>
                                <option v-for="item in game_type" :value="item.id">{{item.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <button type="submit" class="btn btn-success" :disabled="isSubmitting">Guardar</button>
                </div>
            </form>
        </div>

        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="mb-2">Lista de dinámicas</h3>
                    <div class="table-responsive">
                        <table id="data-table-list-exams" class="table table-hover-animation table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Juego</th>
                                    <th>Título</th>
                                    <th>Fecha creación</th>
                                    <th>Estado</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(game, index) in this.games" v-bind:key="game.id" v-bind:index="index">
                                    <td>
                                        <p style="width: 15px">
                                            {{ (index = index + 1) }}
                                        </p>
                                    </td>
                                    <td>
                                        <p style="width: 140px">
                                            {{ game.game_type }}
                                        </p>
                                    </td>
                                    <td>
                                        <p style="width: 140px">
                                            {{ game.name }}
                                        </p>
                                    </td>

                                    <td>{{ moment(game.created_at).format('DD/MM/YYYY hh:mm A') }}</td>
                                    <td>
                                        <span class="badge badge-success" v-if="game.status === 1">Activo</span>
                                        <span class="badge badge-secondary" v-else>Inactivo</span>
                                    </td>
                                    <td>
                                        <select v-model="optionSelected" @change="getOptionSelected(game)" id="item">
                                            <option value="0" disabled selected>Seleccione Categoría</option>
                                            <option v-for="item in options" :value="item.value">{{item.label}}</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="col-md-12 text-center">
                    <div class="alert alert-primary py-1" role="alert">
                        Solo puede activar una dinámica por tipo de juego
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import language from '../../../api/traduction_es';

export default {
    props: {
        course: Object,
        game_type: Array,
    },

    data() {
        return {
            moment: moment,
            loading: false,
            form: {},
            isSubmitting: false,
            options: [{
                    value: '1',
                    label: 'Configurar',
                },
                {
                    value: '2',
                    label: 'Activar/Desactivar',
                },
            ],
            games: null,
            optionSelected: '0',
        };
    },
    created() {
        this.initForm();
    },
    mounted() {
        this.listGames();
    },

    methods: {
        initForm() {
            this.form = {
                name: null,
                game_type: 0,
            };
        },

        listGames() {
            axios
                .get(`/course/game/${this.course.id}/list`)
                .then((response) => {
                    if (response.data.error) {
                        this.message = 'Sin examenes registrados';
                    } else {
                        this.games = response.data;
                    }
                    this.loadDataTable();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        loadDataTable() {
            $('#data-table-list-exams').DataTable().destroy();
            this.$nextTick(function () {
                $('#data-table-list-exams').DataTable(language);
            });
        },

        validateFields() {
            if (!this.form.name || this.form.name.trim() === '' || this.form.name.length === 0) {
                this.$message.warning('Titulo esta vacio!');
                return false;
            }

            if (this.form.name.length > 255) {
                this.$message.warning('Titulo demasiado largo!');
                return false;
            }

            if (!this.form.game_type || this.form.game_type.length === 0) {
                this.$message.warning('No ha seleccionado el tipo de juego');
                return false;
            }

            return true;
        },

        async submit() {
            if (this.validateFields()) {
                this.isSubmitting = true;
                const formdata = new FormData();
                formdata.append('name', this.form.name);
                formdata.append('game_type_id', this.form.game_type);
                formdata.append('course_id', this.course.id);
                formdata.append('game_for', 'course');
                try {
                    this.loading = true;
                    const request = await axios({
                        url: '/course/game/store',
                        method: 'post',
                        data: formdata,
                    });
                    const response =
                        request.status == 200 ?
                        this.$message.success('La dinámica ha sido registrada correctamente') :
                        await this.$message.warning('Error al validar datos');
                    this.isSubmitting = false;
                    this.loading = false;
                    this.listGames();
                    this.initForm();
                } catch (error) {
                    this.isSubmitting = false;
                    this.loading = false;
                    console.log(error);
                }
            }
        },

        getOptionSelected(game) {
            let option = this.optionSelected;
            switch (option) {
                case '1':
                    document.location.href = `/course/game/edit/${game.id}`;
                    break;
                case '2':
                    this.activateGame(game.id, game.course_id, game.game_type_id);
                    this.optionSelected = '';
                    break;
                default:
                    console.log('Error');
                    break;
            }
        },

        async activateGame(id, course_id, game_type_id) {
            const formdata = new FormData();
            formdata.append('id', id); // game id
            formdata.append('course_id', course_id); // course id
            formdata.append('game_type_id', game_type_id); // game_type_id
            try {
                const request = await axios({
                    url: '/course/game/activate',
                    method: 'post',
                    data: formdata,
                });

                if ((await request.data) == 'success') {
                    this.$message.success('El juego ha sido activado correctamente');
                } else {
                    this.$message.warning('Configure el juego antes de activarlo');
                }
                this.listGames();
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
